import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import Utils from '@/util'

export default {
  computed: {
    ...mapState({
      isCreatingNewPresentation: (state) => state.isCreatingNewPresentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    ...mapActions(['createNewPresentationAction', 'setErrorOnInternalServerAction', 'setCurrentUserHasCreatedPresentationAction']),
    createNewPresentation(trigger, queryParams = {}) {
      try {
        if (this.isCreatingNewPresentation) {
          return
        }
        this.createNewPresentationAction({
          trigger,
          onSuccess: this.onCreateNewPresentationSuccess,
          onFailure: this.onCreateNewPresentationFailure,
          queryParams,
        })
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async onCreateNewPresentationSuccess() {
      this.setCurrentUserHasCreatedPresentationAction()
    },
    onCreateNewPresentationFailure(error) {
      if (error && error.body && error.body.message) {
        return Utils.showToastError(error.body.message)
      }
      if (error && error.body && error.body.errors) {
        return Utils.showToastError(JSON.stringify(error.body.errors))
      }
      Sentry.captureException(error)
      return this.setErrorOnInternalServerAction('Cannot create presentation')
    },
  },
}
